import * as React from "react";
import { useEffect } from "react";

interface ColorOption {
  name: string;
  value: string;
  colorClass?: string;
  count?: number;
}

interface SearchColorsProps {
  title?: string;
  colors?: ColorOption[];
  className?: string;
  onColorClick?: (color: string) => void;
}

export const SearchColors: React.FC<SearchColorsProps> = ({
  title = "Colours",
  colorsData = [
    { name: "Beige", value: "beige", colorClass: "bg-orange-100", count: 5 },
    { name: "Sage", value: "sage", colorClass: "bg-green-200", count: 3 },
    { name: "Navy", value: "navy", colorClass: "bg-blue-900", count: 8 },
    { name: "Burgundy", value: "burgundy", colorClass: "bg-red-900", count: 2 },
    { name: "Lavender", value: "lavender", colorClass: "bg-purple-300", count: 4 },
    { name: "Dusty Blue", value: "dusty-blue", colorClass: "bg-blue-300", count: 6 },
    { name: "Forest Green", value: "forest-green", colorClass: "bg-green-800", count: 3 },
    { name: "Pink", value: "pink", colorClass: "bg-pink-300", count: 7 },
    { name: "Turquoise", value: "turquoise", colorClass: "bg-teal-400", count: 2 }
  ],
  className = "",
  onColorClick,
}) => {

 const [colors, setColors] = React.useState<ColorOption[]>(colorsData);

  useEffect(() => {
    // This effect can be used to fetch suggestions dynamically if needed
      // For now, we are using static suggestions

      window.addEventListener('searchrequest-colors-complete', (event) => {
        const newColors = event.detail.colors as ColorOption[];
        if (newColors && newColors.length > 0) {
          setColors(newColors);
        }
      });
  
      return () => {
        window.removeEventListener('searchrequest-colors-complete', (event) => {
          const newColors = event.detail.colors as ColorOption[];
          if (newColors && newColors.length > 0) {
            setColors(newColors);
          }
        });
      };
    }, []);
    

  return (
    <div className={`w-full ${className}`}>
      <p className="b4--bold mb-4">{title}</p>
      <div className="flex flex-row space-y-2">
        {colors.map((color, index) => (
          <button
            key={index}
            onClick={() => onColorClick?.(color.value)}
            className="flex flex-row items-center justify-between w-full p-2 hover:bg-gray-100 transition-colors"
          >
            <div className="flex items-center space-x-2">
              <div 
                className={`w-6 h-6 ${color.colorClass || 'bg-gray-200'}`}
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
